import {NEW_REGISTARTION_DATA_SUCCESS,
    NEW_REGISTARTION_DATA_ERROR,
    NEW_REGISTARTION_DATA_START,
    FIRST_TIME_APPROVAL_SUCCESS,
    FIRST_TIME_APPROVAL_ERROR,
    FIRST_TIME_APPROVAL_START
} from  '../Constants/NewRegistrationConstant'
  
const initialState = {
    loading: false,
    data: [],
    firstTimeApproval:[]
   
};
  
export default function NewRegistrationReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case NEW_REGISTARTION_DATA_START:
        return {
          ...state,
          data: [],
          loading: true,
        };
      case NEW_REGISTARTION_DATA_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case NEW_REGISTARTION_DATA_ERROR:
        return {
          ...state,
          loading: false,
          data: [],
          message: action.error.message,
        };
        case FIRST_TIME_APPROVAL_START:
        return {
          ...state,
          firstTimeApproval: [],
          loading: true,
        };
      case FIRST_TIME_APPROVAL_SUCCESS:
        return {
          ...state,
          firstTimeApproval: action.payload,
          loading: false,
        };
      case FIRST_TIME_APPROVAL_ERROR:
        return {
          ...state,
          loading: false,
          firstTimeApproval: [],
          message: action.error.message,
        };
    
      default:
        return state;
    }
}
  